// extracted by mini-css-extract-plugin
export default {"button":"Questionnaire_button__e85Ai","container":"Questionnaire_container__6ykqz","buttons":"Questionnaire_buttons__REuGS"};